import { IClientValidator } from "./IClientValidator.js";
import { ValidatorBase } from "./validator-base.js";

/**
 * Works with RequiredIfValueAttribute.cs to perform unobtrusive validation in MVC against inputs
 * that are required dependent on another property. For example, a store selectedis required if the
 * delivery method is deliver to store.
 */
export class RequiredIfValue extends ValidatorBase implements IClientValidator {
    public validate(value: string, element: HTMLInputElement, params: any): boolean {
        let otherElement = this.elementByName(params.otherproperty);

        if (!otherElement?.value) {
            return true;
        }

        let otherObjectValue = otherElement.value.toLowerCase();

        // Always compare as lowercase to catch True/true/TRUE etc.
        if (params.othervalue.toLowerCase() === otherObjectValue) {
            if (element.value == null || element.value == undefined) {
                return true;
            }

            return element.value.trim() !== "";
        }

        return true;
    }
}

window.validators = window.validators || {};
window.validators.requiredifvalue = new RequiredIfValue();
